import React from "react";
import { Link } from "react-router-dom";
import styles from './404.module.css';

function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Ilustração SVG Moderna e Minimalista */}
        <div className={styles.illustration}>
          <svg viewBox="0 0 200 200" className={styles.svgIcon}>
            <circle cx="100" cy="100" r="90" fill="#f3f4f6" />
            <path 
              d="M70 100C70 83.4315 83.4315 70 100 70C116.569 70 130 83.4315 130 100" 
              stroke="#6366f1" strokeWidth="8" strokeLinecap="round" 
            />
            <circle cx="85" cy="115" r="6" fill="#6366f1" />
            <circle cx="115" cy="115" r="6" fill="#6366f1" />
          </svg>
        </div>

        <h1 className={styles.title}>404</h1>
        <h2 className={styles.subtitle}>Página não encontrada</h2>
        <p className={styles.description}>
          Parece que você tentou acessar um caminho que não existe mais ou foi movido.
        </p>

        <div className={styles.buttonGroup}>
          <Link to="/" className={styles.primaryButton}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            Início
          </Link>
        </div>
      </div>
      
      <div className={styles.blob}></div>
    </div>
  );
}

export default NotFoundPage;